import { FC } from 'react';

export const ExclamationMark: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect x="10" y="2" width="4" height="12" rx="1" fill="currentColor" />
		<circle cx="12" cy="18" r="2.5" fill="currentColor" />
	</svg>
);
